// DS: C118
import React, { useRef, useMemo, useCallback, useEffect } from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import { PopupContext } from '@wix/da-ds/pkg/popups/PopupContext';
import CloseButton from '../../Button/CloseButton';
import UserSearchField from '../../UserSearchField';
import noop from '../../utils/noop';
import s from './UserInput.scss';
export const UserInput = ({ users, className, candidates, scrollContainerClassName, prefix, placeholder, onAddUser, onRemoveUser, onRemoveAll, onKeyDown, onNoMatchingUsers, withClearButton, disabled, additionalExcludedUsers })=>{
    const scrollAreaRef = useRef(null);
    const inputRef = useRef(null);
    const renderUser = (user, index)=>/*#__PURE__*/ React.createElement("div", {
            className: classnames(s['item'], s['item-flex']),
            key: `selected-${user.userId}-${index}`
        }, user.username, /*#__PURE__*/ React.createElement(CloseButton, {
            className: s['close-button'],
            view: "b5-3",
            onClick: (e)=>{
                onRemoveUser(user);
                e.stopPropagation();
            }
        }));
    const onInputKeyDown = useCallback((e)=>{
        const target = e.target;
        if (e.key === 'Backspace' && target.value.length === 0 && users.length > 0) {
            onRemoveUser(users[users.length - 1]);
        }
        onKeyDown && onKeyDown(e);
    }, [
        users,
        onRemoveUser,
        onKeyDown
    ]);
    const mergedExclusiveUsers = useMemo(()=>[
            ...users,
            ...additionalExcludedUsers || []
        ], [
        users,
        additionalExcludedUsers
    ]);
    useEffect(()=>{
        if (scrollAreaRef.current) {
            scrollAreaRef.current.scrollTop = scrollAreaRef.current.scrollHeight;
        }
    }, [
        users.length
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className),
        onClick: (e)=>inputRef.current && inputRef.current.focus()
    }, prefix && // We're expecting the client to provide a label for this field, so hide this prefix to avoid
    // additional noise
    /*#__PURE__*/ React.createElement("span", {
        className: s['prefix'],
        "aria-hidden": "true"
    }, prefix), /*#__PURE__*/ React.createElement(Flex, {
        className: classnames(s['item-container'], prefix && s['has-prefix'], scrollContainerClassName),
        alignItems: "flex-start",
        wrap: "wrap",
        innerRef: scrollAreaRef
    }, users.map(renderUser), /*#__PURE__*/ React.createElement(PopupContext.Provider, {
        value: {
            isInPopup: true,
            setScrollableContentRef: noop
        }
    }, /*#__PURE__*/ React.createElement(UserSearchField, {
        key: "searchField",
        candidates: candidates,
        onUserSelect: onAddUser,
        excludedUsers: mergedExclusiveUsers,
        className: classnames(s['user-input'], s['item-flex']),
        inputClassName: s['user-input-textfield'],
        placeholder: placeholder,
        inputRef: inputRef,
        withClearButton: withClearButton,
        onClear: onRemoveAll,
        onInputKeyDown: onInputKeyDown,
        onNoMatchingUsers: onNoMatchingUsers,
        popupFixedPosition: true,
        isChatContext: true,
        disabled: disabled
    }))));
};
UserInput.displayName = 'UserInput';
export default UserInput;
